import { ClothesType } from './clothes';

export type InventoryDrop = {
	serverId: string;
	position: { x: number; y: number; z: number };
	dimension: number;
	heading: number;
	expiresAt: number;
};

export type PackedInventory = {
	id: string;
	type: InventoryType;
	ownerId: string;
	items: Array<PackedItemStack | null>;
	capacity: number;
	isInfinite: boolean;
	isTemporary: boolean;
	drop?: InventoryDrop | null;
};

// Compatibility with consumers added on develop after the original revamp.
export type InventorySnapshot = PackedInventory;

export type InventoryExchangeConfirmation = { endsAt: number | null; serverNow: number };

export type InventoryCharacterAccess = {
	inventoryIds: string[];
	exchangeInventoryIds: string[];
	exchangePartnerId: string | null;
};

export type PackedItemStack = {
	stackId?: string;
	id: string;
	count: number;
	data: ItemData | undefined;
};

export const equipmentSlotByClothesType: Record<ClothesType, number> = {
	[ClothesType.GLASSES]: 0,
	[ClothesType.HAT]: 1,
	[ClothesType.MASK]: 2,
	[ClothesType.EARRINGS]: 3,
	[ClothesType.ACCESSORY]: 4,
	[ClothesType.ARMOR]: 5,
	[ClothesType.BRACELET]: 6,
	[ClothesType.TOP]: 7,
	[ClothesType.WATCHES]: 8,
	[ClothesType.SUIT]: 9,
	[ClothesType.PANTS]: 10,
	[ClothesType.BACKPACK]: 11,
	[ClothesType.SHOES]: 12,
};

export enum ItemType {
	OTHER = 'other',
	CLOTHES = 'clothes',
	BACKPACK = 'backpack',
	FOOD = 'food',
}

export enum ItemAction {
	USE = 'use',
	SPLIT = 'split',
	DROP = 'drop',
	EQUIP = 'equip',
	UNEQUIP = 'unequip',
	GIVE_HANDS = 'give_hands',
	TAKE_HANDS = 'take_hands',
}

// Метаданные предметов
export interface BreakableData {
	durability: number;
}

export interface ClothesData {
	type: ClothesType;
}

export interface BackpackData {
	inventoryId: string;
}

export type ItemData = {
	breakable?: BreakableData;
	clothes?: ClothesData;
	backpack?: BackpackData;
};

export enum InventoryType {
	EQUIPMENT = 'equipment',
	HOTBAR = 'hotbar',
	PLAYER = 'player',
	BACKPACK = 'backpack',
	EXCHANGE = 'exchange',
	VEHICLE = 'vehicle',
	HOUSE = 'house',
	DROPPED = 'dropped',
}

export function isPlayerInventory(inventoryType: InventoryType): boolean {
	return (
		inventoryType === InventoryType.EQUIPMENT ||
		inventoryType === InventoryType.HOTBAR ||
		inventoryType === InventoryType.PLAYER
	);
}

export function isAllowedToDropInventory(inventoryType: InventoryType): boolean {
	if (isPlayerInventory(inventoryType)) {
		return true;
	}

	switch (inventoryType) {
		case InventoryType.BACKPACK:
		case InventoryType.VEHICLE:
		case InventoryType.HOUSE:
			return true;
		default:
			return false;
	}
}

export interface Item {
	id: string; // Уникальный ID экземпляра предмета в ячейке
	itemId: string; // Базовый ID предмета для стакания
	name: string;
	subName?: string;
	count: number;
	image?: string;
	type: ItemType;
	availableActions: ItemAction[];
	stackable: boolean;
	slots?: number; // Количество слотов для рюкзака
	hasUsageLimit?: boolean;
	usageLimit?: number;
	usageLeft?: number;
	tags?: string[];
	data?: ItemData;
}

export interface InventoryCell {
	id: string;
	item?: Item;
	// type: InventoryCellType;
	position: number;
	isClosed?: boolean;
	width?: number;
	height?: number;
	placeholderImage?: string;
	placeholderText?: string;
	allowedTypes?: ItemType[];
}

export interface InventoryBackpack {
	id: string;
	name: string;
	cells: InventoryCell[];
	isActive: boolean;
}

export interface DroppedItem {
	id: string;
	count: number;
	data?: ItemData;
}

export interface HeldItem {
	inventoryType: InventoryType;
	itemSlot: number;
}
